import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { AuditAssessmentStats } from "@/types/audit";

interface AuditTableProps {
  assessments: AuditAssessmentStats[];
  downloadingAssessmentId: string | null;
  onDownload: (assessmentId: string) => void;
}

const toPercent = (numerator: number, denominator: number) => {
  if (denominator <= 0) return 0;
  return Math.round((numerator / denominator) * 100);
};

export const AuditTable = ({
  assessments,
  downloadingAssessmentId,
  onDownload,
}: AuditTableProps) => {
  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableHead>Title</TableHead>
          <TableHead>Submissions</TableHead>
          <TableHead>Course</TableHead>
          <TableHead>AI Suggestions</TableHead>
          <TableHead>Report</TableHead>
        </TableRow>
      </TableHeader>
      <TableBody>
        {assessments.length === 0 && (
          <TableRow>
            <TableCell className="px-2 py-8 text-sm text-muted-foreground" colSpan={6}>
              No assessments found.
            </TableCell>
          </TableRow>
        )}
        {assessments.map((assessment) => {
          const totalSuggestions = assessment.suggestions?.total || 0;
          const approved = assessment.suggestions?.approved || 0;
          const approvalPercent = toPercent(approved, totalSuggestions);
          const rejected = assessment.suggestions?.rejected || 0;
          const rejectPercent = toPercent(rejected, totalSuggestions);
          const ignored = Math.max(0, totalSuggestions - approved - rejected);
          const ignoredPercent = toPercent(ignored, totalSuggestions);


          return (
            <TableRow key={assessment.assessmentId}>
              <TableCell>
                {assessment.title}
              </TableCell>
              <TableCell>
                {assessment.totalDocuments}
              </TableCell>
              <TableCell>
                {assessment.courseReference || "-"}
              </TableCell>
              <TableCell>
                <div className="gap-2 flex">
                  <Badge className="bg-white border-green-600 text-foreground">{approvalPercent}%</Badge>
                  <Badge className="bg-white border-red-600 text-foreground">{rejectPercent}%</Badge>
                  <Badge className="bg-white border-gray-600 text-foreground">{ignoredPercent}%</Badge>
                </div>
              </TableCell>
              <TableCell>
                <Button
                  variant="outline"
                  size="sm"
                  disabled={downloadingAssessmentId === assessment.assessmentId}
                  onClick={() => onDownload(assessment.assessmentId)}
                  className="h-9 rounded-xl px-4"
                >
                  Download
                </Button>
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
